export default __webpack_public_path__ + "static/media/mo_background@2x.494c996d.png";